<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div
                  class="
                    card card-custom
                    gutter-b
                    bg-transparent
                    shadow-none
                    border-0
                  "
                >
                  <div
                    class="
                      card-header
                      align-items-center
                      border-bottom-dark
                      px-0
                    "
                  >
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Coupon Setting
                      </h3>
                    </div>
                    <div class="icons d-flex">
                      <button
                        class="btn ml-2 p-0 kt_notes_panel_toggle"
                        data-toggle="tooltip"
                        title=""
                        data-placement="right"
                        data-original-title="Check out more demos"
                        v-if="$parent.permissions.includes('coupon-manage')"
                      >
                        <span
                          class="
                            bg-secondary
                            h-30px
                            font-size-h5
                            w-30px
                            d-flex
                            align-items-center
                            justify-content-center
                            rounded-circle
                            shadow-sm
                          "
                          v-on:click="display_form = !display_form"
                        >
                          <svg
                            width="25px"
                            height="25px"
                            viewBox="0 0 16 16"
                            class="bi bi-plus white"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                            ></path>
                          </svg>
                        </span>
                      </button>
                      <!-- <a href="#" onclick="printDiv()" class="ml-2">
                                            <span class="icon h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle ">
                                                <svg width="15px" height="15px" viewBox="0 0 16 16" class="bi bi-printer-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5z"></path>
                                                    <path fill-rule="evenodd" d="M11 9H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"></path>
                                                    <path fill-rule="evenodd" d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"></path>
                                                </svg>
                                            </span>
                                        </a>
                                        <a href="#" class="ml-2">
                                            <span class="icon h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle ">
                                                <svg width="15px" height="15px" viewBox="0 0 16 16" class="bi bi-file-earmark-text-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7 2l.5-2.5 3 3L10 5a1 1 0 0 1-1-1zM4.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"></path>
                                                </svg>
                                            </span>
                                        </a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div>
                      <div class="table-responsive" id="printableTable">
                        <div
                          id="CouponSetting_wrapper"
                          class="dataTables_wrapper no-footer"
                        >
                          <div
                            class="dataTables_length"
                            id="CouponSetting_length"
                          >
                            <label
                              >Show
                              <select
                                name="CouponSetting_length"
                                class=""
                                v-model="limit"
                                v-on:change="fetchCouponSetting()"
                              >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                              </select>
                              entries</label
                            >
                          </div>

                          <div
                            id="CouponSetting_filter"
                            class="dataTables_filter"
                          >
                            <label
                              >Search:<input
                                type="text"
                                class=""
                                placeholder=""
                                v-model="searchParameter"
                                @keyup="fetchCouponSetting()"
                            /></label>
                            <button
                              v-if="this.searchParameter != ''"
                              @click="clearSearch"
                            >
                              clear
                            </button>
                          </div>
                          <table
                            id="productUnitTable"
                            class="display dataTable no-footer"
                            role="grid"
                          >
                            <thead class="text-body">
                              <tr role="row">
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-sort="ascending"
                                  aria-label="ID: activate to sort column descending"
                                  style="width: 31.25px"
                                  @click="sorting('id')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'id'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'id'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  "
                                >
                                  ID
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="coupon_setting: activate to sort column ascending"
                                  style="width: 95.5288px"
                                  @click="sorting('code')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'code'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'code'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  "
                                >
                                  Code
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="Phone No: activate to sort column ascending"
                                  style="width: 81.8109px"
                                >
                                  Coupon For
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="Email: activate to sort column ascending"
                                  style="width: 114.84px"
                                  @click="sorting('type')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'type'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'type'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  "
                                >
                                  Type
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="Address: activate to sort column ascending"
                                  style="width: 158.462px"
                                >
                                  Amount {{getCurrencyTitle()}}
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="No Of Product: activate to sort column ascending"
                                  style="width: 108.67px"
                                >
                                  Expiry date
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="Stock Quantity: activate to sort column ascending"
                                  style="width: 112.917px"
                                >
                                  Limit per user
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="Stock Quantity: activate to sort column ascending"
                                  style="width: 112.917px"
                                >
                                  Limit per coupon
                                </th>
                                <th
                                  v-if="
                                    $parent.permissions.includes(
                                      'coupon-manage'
                                    )
                                  "
                                  class="no-sort sorting_disabled"
                                  rowspan="1"
                                  colspan="1"
                                  aria-label="Action"
                                  style="width: 53.1891px"
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody class="kt-table-tbody text-dark">
                              <tr
                                class="kt-table-row kt-table-row-level-0 odd"
                                role="row"
                                v-for="coupon_setting in coupon_settings"
                                v-bind:key="coupon_setting.coupon_id"
                              >
                                <td class="sorting_1">
                                  {{ coupon_setting.coupon_id }}
                                </td>
                                <td>
                                  {{ coupon_setting.coupon_code }}
                                </td>
                                <td>
                                  {{
        Number(coupon_setting.coupon_type) === 1 
            ? "General" 
            : Number(coupon_setting.coupon_type) === 2 
                ? "Categories" 
                : Number(coupon_setting.coupon_type) === 3
                    ? "Products"
                    : "Brands"
    }}
                                </td>
                                <td>
                                  {{ coupon_setting.type }}
                                </td>
                                <td>
                                  {{ coupon_setting.coupon_amount }}
                                </td>
                                <td>
                                  {{ coupon_setting.coupon_expiry_date }}
                                </td>
                                <td>
                                  {{
                                    coupon_setting.coupon_usage_limit_per_user
                                  }}
                                </td>
                                <td>
                                  {{
                                    coupon_setting.coupon_usage_limit_per_coupon
                                  }}
                                </td>
                                <td
                                  v-if="
                                    $parent.permissions.includes(
                                      'coupon-manage'
                                    )
                                  "
                                >
                                  <a
                                    href="javascript:void(0)"
                                    class="click-edit"
                                    id="click-edit1"
                                    data-toggle="tooltip"
                                    title=""
                                    data-placement="right"
                                    data-original-title="Check out more demos"
                                    @click="editCouponSetting(coupon_setting)"
                                    ><i class="fa fa-edit"></i
                                  ></a>
                                  <a
                                    class=""
                                    href="#"
                                    @click="
                                      deleteCouponSetting(
                                        coupon_setting.coupon_id
                                      )
                                    "
                                    ><i class="fa fa-trash"></i
                                  ></a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <ul class="pagination pagination-sm m-0 float-right">
                            <li
                              v-bind:class="[
                                { disabled: !pagination.prev_page_url },
                              ]"
                            >
                              <a
                                class="page-link"
                                href="#"
                                @click="
                                  fetchCouponSetting(pagination.prev_page_url)
                                "
                                >Previous</a
                              >
                            </li>

                            <li class="disabled">
                              <a class="page-link text-dark" href="#"
                                >Page {{ pagination.current_page }} of
                                {{ pagination.last_page }}</a
                              >
                            </li>

                            <li
                              v-bind:class="[
                                { disabled: !pagination.next_page_url },
                              ]"
                              class="page-item"
                            >
                              <a
                                class="page-link"
                                href="#"
                                @click="
                                  fetchCouponSetting(pagination.next_page_url)
                                "
                                >Next</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel"
      v-if="display_form"
      :class="display_form ? 'offcanvas-on' : ''"
    >
      <div
        class="
          offcanvas-header
          d-flex
          align-items-center
          justify-content-between
          pb-3
        "
      >
        <h4 class="font-size-h4 font-weight-bold m-0">Add coupon_setting</h4>
        <a
          href="#"
          class="
            btn btn-sm btn-icon btn-light btn-hover-primary
            kt_notes_panel_close
          "
          v-on:click="display_form = 0"
        >
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 16 16"
            class="bi bi-x"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            ></path>
          </svg>
        </a>
      </div>
      <form id="myform">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="text-dark">Code </label>
              <input
                type="text"
                name="text"
                v-model="coupon_setting.code"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('code')"
                v-text="errors.get('code')"
              ></small>
            </div>

            <div class="form-group">
              <label class="text-dark">Description </label>
              <input
                type="text"
                name="text"
                v-model="coupon_setting.description"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('description')"
                v-text="errors.get('description')"
              ></small>
            </div>

            <div class="form-group">
              <label class="text-dark">Discount type </label>
              <select v-model="coupon_setting.type">
                <option value="fixed">Fixed</option>
                <option value="percentage">Percentage</option>
              </select>
              <small
                class="form-text text-danger"
                v-if="errors.has('type')"
                v-text="errors.get('type')"
              ></small>
            </div>

            <div class="form-group">
              <label class="text-dark">Coupon amount </label>
              <input
                type="text"
                name="text"
                v-model="coupon_setting.amount"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('amount')"
                v-text="errors.get('amount')"
              ></small>
            </div>

            <div class="form-group">
              <label class="text-dark">Coupon Expiry Date </label>
              <input
                type="date"
                name="text"
                v-model="coupon_setting.expiry_date"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('expiry_date')"
                v-text="errors.get('expiry_date')"
              ></small>
            </div>

            <div class="form-group">
              <label class="text-dark">Usage Limit Per User </label>
              <input
                type="text"
                name="text"
                v-model="coupon_setting.usage_limit_per_user"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('usage_limit_per_user')"
                v-text="errors.get('usage_limit_per_user')"
              ></small>
            </div>

            <div class="form-group">
              <label class="text-dark">Usage Limit Per Coupon </label>
              <input
                type="text"
                name="text"
                v-model="coupon_setting.usage_limit_per_coupon"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('usage_limit_per_coupon')"
                v-text="errors.get('usage_limit_per_coupon')"
              ></small>
            </div>

            <div class="form-group">
              <label class="text-dark">Coupon type </label>
              <select v-model="coupon_setting.coupon_type">
                <option value="1">General</option>
                <option value="2">Category</option>
                <option value="3">Product</option>
                <option value="4">Brand</option>
              </select>
              <small
                class="form-text text-danger"
                v-if="errors.has('type')"
                v-text="errors.get('type')"
              ></small>
            </div>

            <div class="form-group" v-if="coupon_setting.coupon_type == 2">
              <label>Categories</label>
  <multiselect
    v-model="coupon_setting.category_id" 
    :options="categories" 
    :custom-label="nameWithLang" 
    placeholder="Select one" 
    label="name" 
    track-by="id"
    :multiple="true"
    :taggable="true"
    @input="setCat"
    @remove="removeCat">
  </multiselect>
</div>

<div class="form-group" v-if="coupon_setting.coupon_type == 3">
  <label>Products</label>
  <fieldset class="form-group mb-3 d-flex">
    <multiselect 
      v-model="coupon_setting.product_id"
      :options="products" 
      :custom-label="nameWithLangTitle" 
      placeholder="Select Product" 
      label="name" 
      track-by="product_id"
      :multiple="true"
      :taggable="true"
      @input="setPro"
    @remove="removePro">
    </multiselect>
  </fieldset>
</div>

<div class="form-group" v-if="coupon_setting.coupon_type == 4">
  <label>Brands</label>
  <fieldset class="form-group mb-3 d-flex">
    <multiselect 
      v-model="coupon_setting.brand_id"
      :options="brands" 
      :custom-label="nameWithLangBrand" 
      placeholder="Select Brand" 
      label="brand_name" 
      track-by="brand_id"
      :multiple="true"
      :taggable="true"
      @input="setBrand"
      @remove="removeBrand">
    </multiselect>
  </fieldset>
</div>

          </div>
        </div>
        <button
          type="button"
          @click="addUpdateCouponSetting()"
          class="btn btn-primary"
        >
          Submit
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import ErrorHandling from "./../../ErrorHandling";
import Multiselect from 'vue-multiselect'
export default {
  components: { Multiselect },
  data() {
    return {
      display_form: 0,
      categories: [],
      category_id:"",
      product_id:"",
      brand_id:"",
      products:[],
      brands:[],
      coupon_setting: {
        id: "",
        code: "",
        product_id:"",
        category_id:"",
        brand_id:"",
        description: "",
        type: "fixed",
        coupon_type:1,
        amount: "",
        expiry_date: "",
        usage_limit_per_user: "",
        usage_limit_per_coupon: "",
      },
      predefinedCategories: [
    ],
    predefinedProducts: [
    ],
    predefinedBrands: [
    ],
      searchParameter: "",
      sortBy: "id",
      sortType: "ASC",
      limit: 10,
      error_message: "",
      edit: false,
      actions: false,
      pagination: {},
      request_method: "",
      coupon_settings: [],
      token: [],
      currency: [],
      errors: new ErrorHandling(),
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },

  methods: {
    nameWithLang (option) {
      console.log(option, 'option');
      return option.detail ? `${option.detail[0].name}` : 'Hey';
    },
    nameWithLangTitle(option) {
      return option.detail ? `${option.detail[0].title}` : "no name";
    },
    nameWithLangBrand(option) {
      return option.brand_name ? `${option.brand_name}` : "no name";
    },
    setCat(value,id) {
      this.$emit("setCategoryInChild",value[value.length-1].id,'push');
    },
    removeCat(removedOption, id){
      this.$emit("setCategoryInChild",removedOption.id,'remove');
    },
    setPro(value,id) {
      this.$emit("setProductInChild",value[value.length-1].id,'push');
    },
    removePro(removedOption, id){
      this.$emit("setProductInChild",removedOption.id,'remove');
    },
    setBrand(value,id) {
      this.$emit("setBrandInChild",value[value.length-1].brand_id,'push');
    },
    removeBrand(removedOption, id){
      this.$emit("setBrandInChild",removedOption.brand_id,'remove');
    },
    fetchCurrency() {
        this.$parent.loading = true;
        var token = localStorage.getItem("token");
        const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        };
        var responseData = {};

        axios
        .get("/api/admin/currency?is_default=1", config)
        .then((res) => {
            if (res.data.status == "Success") {
            this.currency = res.data.data;
            }
        })
        .finally(() => (this.$parent.loading = false));
    },
    fetchCouponSetting(page_url) {
      this.$parent.loading = true;
      let vm = this;
      page_url = page_url || "/api/admin/coupon_setting";
      var arr = page_url.split("?");

      if (arr.length > 1) {
        page_url += "&limit=" + this.limit;
      } else {
        page_url += "?limit=" + this.limit;
      }
      if (this.searchParameter != null) {
        page_url += "&searchParameter=" + this.searchParameter;
      }
      page_url += "&sortBy=" + this.sortBy + "&sortType=" + this.sortType;
      var responseData = {};

      axios
        .get(page_url, this.token)
        .then((res) => {
          this.coupon_settings = res.data.data;
          vm.makePagination(res.data.meta, res.data.links);
        })
        .finally(() => (this.$parent.loading = false));
    },

    fetchCategories() {
      this.$parent.$parent.loading = true;
      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var responseData = {};

      axios
        .get("/api/admin/category?getAllData=1&getDetail=1", config)
        .then((res) => {
          if (res.data.status == "Success") {
            this.categories = res.data.data;
          }
        })
        .finally(() => (this.$parent.$parent.loading = false));
    },
    fetchProducts() {
      this.$parent.$parent.loading = true;
      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var responseData = {};

      axios
        .get("/api/admin/product?getAllData=1&getDetail=1", config)
        .then((res) => {
          if (res.data.status == "Success") {
            this.products = res.data.data;
          }
        })
        .finally(() => (this.$parent.$parent.loading = false));
    },
    fetchBrands() {
      this.$parent.$parent.loading = true;
      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var responseData = {};

      axios
        .get("/api/admin/brand", config)
        .then((res) => {
          if (res.data.status == "Success") {
            this.brands = res.data.data;
          }
        })
        .finally(() => (this.$parent.$parent.loading = false));
    },


    makePagination(meta, links) {
      let pagination = {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };

      this.pagination = pagination;
    },
    getCurrencyTitle() {
      return this.currency == null ? "" : "(" + this.currency.title + ")";
    },
    deleteCouponSetting(id) {
      if (confirm("Are You Sure?")) {
        this.$parent.loading = true;
        axios
          .delete(`/api/admin/coupon_setting/${id}`, this.token)
          .then((res) => {
            if (res.data.status == "Success") {
              this.$toaster.success(res.data.message);
              this.fetchCouponSetting();
            }
          })
          .catch((err) => console.log(err))
          .finally(() => (this.$parent.loading = false));
      }
    },
    addUpdateCouponSetting() {
      this.$parent.loading = true;
      var url = "/api/admin/coupon_setting";
      if (this.edit === false) {
        // Add
        this.request_method = "post";
      } else {
        // Update
        var url = "/api/admin/coupon_setting/" + this.coupon_setting.id;
        this.request_method = "put";
      }
      axios[this.request_method](url, this.coupon_setting, this.token)
        .then((res) => {
          if (res.data.status == "Success") {
            this.display_form = 0;
            this.$toaster.success(res.data.message);
            this.clearForm();
            this.fetchCouponSetting();
          } else {
            this.$toaster.error(res.data.message);
          }
        })
        .catch((error) => {
          this.error_message = "";
          this.errors = new ErrorHandling();
          if (error.response.status == 422) {
            if (error.response.data.status == "Error") {
              this.error_message = error.response.data.message;
            } else {
              this.errors.record(error.response.data.errors);
            }
          }
        })
        .finally(() => (this.$parent.loading = false));
    },
    editCouponSetting(coupon_setting) {
      this.edit = true;
      this.display_form = 1;
      this.errors = new ErrorHandling();
      this.coupon_setting.id = coupon_setting.coupon_id;
      this.coupon_setting.code = coupon_setting.coupon_code;
      this.coupon_setting.description = coupon_setting.coupon_description;
      this.coupon_setting.type = coupon_setting.type;
      this.coupon_setting.coupon_type = coupon_setting.coupon_type;
      this.coupon_setting.amount = coupon_setting.coupon_amount;
      this.coupon_setting.expiry_date = coupon_setting.coupon_expiry_date;
      this.coupon_setting.usage_limit_per_user =
        coupon_setting.coupon_usage_limit_per_user;
      this.coupon_setting.usage_limit_per_coupon =
        coupon_setting.coupon_usage_limit_per_coupon;

      
         // Set selected categories and products
    this.coupon_setting.category_id = [...this.predefinedCategories];
    this.coupon_setting.product_id = [...this.predefinedProducts];
            

     // Set selected categories and products dynamically from coupon_setting
     this.coupon_setting.category_id = coupon_setting.categories.map(category => ({
      id: category.category_id,
      detail:  [{ name: category.category_name }]	 || [{ name: "Default Name" }], // default if detail is missing
    }));

    // Assuming products are set similarly
    this.coupon_setting.product_id = coupon_setting.products.map(product => ({
      product_id: product.product_id,
      detail: [{ title: product.title }] || [{ name: "Default Product Name" }],
    }));

    // Set selected brands
    this.coupon_setting.brand_id = coupon_setting.brands ? coupon_setting.brands.map(brand => ({
      brand_id: brand.brand_id,
      brand_name: brand.brand_name || "Default Brand Name",
    })) : [];
    },
    clearForm() {
      this.edit = false;
      this.coupon_setting.id = null;
      this.coupon_setting.code = "";
      this.coupon_setting.description = "";
      this.coupon_setting.type = "fixed";
      this.coupon_setting.coupon_type =1;
      this.coupon_setting.amount = "";
      this.coupon_setting.expiry_date = "";
      this.coupon_setting.usage_limit_per_user = "";
      this.coupon_setting.usage_limit_per_coupon = "";
    },
    sorting(sortBy) {
      this.sortBy = sortBy;
      this.sortType =
        this.sortType == "asc" || this.sortType == "ASC"
          ? (this.sortType = "desc")
          : (this.sortType = "asc");
      this.fetchCouponSetting();
    },
    clearSearch() {
      (this.searchParameter = ""), this.fetchCouponSetting();
    },
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchCurrency();
    this.fetchCouponSetting();
    this.fetchCategories();
    this.fetchProducts();
    this.fetchBrands();
    this.coupon_setting.category_id = this.predefinedCategories; // Set predefined as selected
    this.coupon_setting.brand_id = this.predefinedBrands; // Set predefined brands as selected

  },
};
</script>
